import React, { useState, useEffect } from 'react'

//Bibliotecas
import styled from 'styled-components'

//Servicios
import GrupoService from '../../../services/GrupoService';

//Componentes
import FlexContainer from '../../../components/common/FlexContainer'
import Button, { SecondaryButton, DangerButton } from '../../../components/common/Button'
import Modal from '../../../components/common/Modal'
import Error from '../../../components/common/Error';

//Imágenes
import { UserX, UserPlus, ChevronDown } from 'react-feather'
import { set } from 'react-hook-form';

function Group({ user, setUser, refreshProfile }) {
    //Estados
    const [groups, setGroups] = useState([]);
    const [isGroup, setIsGroup] = useState(user?.group);
    const [group, setGroup] = useState([]);
    const [groupId, setGroupId] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(false);
    const [groupSelection, setGroupSelection] = useState([]);
    const [salirModal, setSalirModal] = useState(false);
    const [error, setError]= useState('');
    const [loading, setLoading] = useState(false);

    //Manipuladores
    function handleToggleSalirModal() {
        setSalirModal(!salirModal);
    }

    function handleCrearGrupo() {
        setLoading(true);
        const integrantes = [];
        integrantes.push({ nombre: user.nombre, id: user._id })//Error here
        groupSelection.forEach((elem) => {
            integrantes.push(elem);
        })
        GrupoService.crearGrupo(integrantes).then((res) => {
            refreshProfile();
            setLoading(false);
        }).catch((err) => {setError(err?.message); setLoading(false)});
    }

    function handleDeshacerGrupo() {
        setLoading(true);
        GrupoService.deshacerGrupo(groupId).then((res) => {
            setSalirModal(false);
            refreshProfile();
            setLoading(false);
        }).catch((err) => {setError(err?.message); setLoading(false)});
    }

    function updateComponent() {
        if (isGroup) {
            GrupoService.obtenerGrupo().then((res) => {
                setGroup(res.integrantesGrupo[0].grupos[0].estudiantes);
                setGroupId(res.integrantesGrupo[0].grupos[0]._id);
            })
        } else {
            GrupoService.obtenerGrupos().then((res) => {
                setGroups(res.estudiantes);
            });
        }
    }

    useEffect(() => {   
        setIsGroup(user?.grupo);
        updateComponent();
    }, [isGroup, user?.grupo]);


    return (
        <FlexContainer margin='0 64px' borderRadius="20px" minHeight="300px" boxShadow='20px 20px 40px rgba(0, 0, 0, 0.25)' justifyContent='top' padding='8px'>
            {isGroup &&
                <>
                    <FlexContainer flexDirection='row' width='100%' justifyContent='space-between' padding='16px' borderRadius='20px' >
                        <h2>Tu grupo</h2>
                        {/*
                        <Avatars>
                            {grmap((estudiante) => (<Avatar src={estudiante.url}></Avatar>))}
                        </Avatars>
                        */}
                    </FlexContainer>
                    <Names>
                        {group.map(estudiante =>
                            <span>{estudiante.nombre}</span>
                        )}
                    </Names>
                    <Button width='60%' onClick={handleToggleSalirModal}><UserX />Salir del grupo</Button>
                    <Modal title="Salir del grupo" state={salirModal} setState={setSalirModal} padding='0' headerPadding='16px'>
                        <FlexContainer borderRadius='5px'>
                            <ModalText>Estás a punto de salir de tu grupo actual<br /><span> Si lo abandonas perderás todo tu progreso </span> <br /> <span>¿Estás seguro de que quieres salir del grupo?</span> </ModalText>
                            <FlexContainer borderRadius='5px' flexDirection='row' margin='16px 0 0 0' justifyContent='right' backgroundColor='var(--color-gris-claro)' padding='16px' >
                                <SecondaryButton width='30%' margin='0 16px' onClick={handleToggleSalirModal}>Cancelar</SecondaryButton>
                                <DangerButton width='40%' margin='0' onClick={handleDeshacerGrupo} loading={loading}>Salir del grupo</DangerButton>
                            </FlexContainer>
                        </FlexContainer>
                    </Modal>
                </>
            }
            {!isGroup &&
                <>
                    <FlexContainer flexDirection='row' width='100%' justifyContent='space-between' padding='16px' borderRadius='20px' >
                        <h2>Tu grupo</h2>
                    </FlexContainer>
                    <Message>Aún no perteneces a ningún grupo<br /><span>Elige a que compañeros quieres unirte</span></Message>
                    <DropDown>
                        <DropDownButton onClick={(e) => setActiveDropdown(!activeDropdown)}>
                            <span>{groupSelection.map((item) => item.nombre && (<>{item.nombre}<br /></>))}</span>
                            <ChevronDown />
                        </DropDownButton>
                        {activeDropdown &&
                            <DropDownContent>
                                {groups.map(grupo => (
                                    <DropDownItem
                                        onClick={e => {
                                            setGroupSelection(() => {
                                                if (Array.isArray(grupo)) {
                                                    return [{ nombre: grupo[0].nombre, id: grupo[0]._id }]
                                                } else {
                                                    const retorno = [];
                                                    grupo.estudiantes.forEach(estudiante => {
                                                        retorno.push({ nombre: estudiante.nombre, id: estudiante.id })
                                                    });
                                                    retorno.push({ _id: grupo._id })
                                                    return retorno;
                                                }
                                            });
                                            setActiveDropdown(false);
                                        }}>
                                        {!Array.isArray(grupo) &&
                                            grupo.estudiantes.map((estudiante) => (<>{estudiante.nombre}<br /></>))
                                        }
                                        {Array.isArray(grupo) &&
                                            <>{grupo[0].nombre}</>
                                        }
                                    </DropDownItem>))}
                            </DropDownContent>
                        }
                    </DropDown>
                    <Button width='60%' onClick={handleCrearGrupo} loading={loading} disabled={groupSelection.length===0?true:undefined}><UserPlus />Unirse</Button>
                    <Error message={error}></Error>
                </>

            }
        </FlexContainer >
    )
}

export default Group

const Avatars = styled.div`
    display:flex;
    flex-direction: row;
    
    img{
        position: relative;

        :nth-child(1){
            border:4px solid var(--color-rosa);
            z-index:3;
        }

        :nth-child(2){
            right:15px;
            border:4px solid var(--color-morado-oscuro);
            z-index:2;
        }
        
        :nth-child(3){
            right:30px;
            border:4px solid var(--color-azul-claro);
            z-index:1;
        }
    }
`;

const Names = styled.div`
    display:flex;
    flex-direction:column;
    margin-top:16px;
    margin-bottom:16px;
    span{
        margin-bottom:8px;
    }
`;

const Message = styled.span`
    margin-top:16px;
    margin-bottom:32px;
    font-weight:700;
    color: var(--color-morado-oscuro);
    span{
        font-weight:400;
        color: var(--color-negro);
    }
`;


const DropDown = styled.div`
    width:80%;
    padding:8px;
    position: relative;
    z-index:1;
`;
const DropDownButton = styled.div`
    padding:8px;
    font-weight:700;
    display:flex;
    align-items:center;
    justify-content:space-between;
    background-color:var(--color-gris-claro);
    border-radius:5px;
    border:2px solid var(--color-morado-oscuro);
    cursor: pointer;
    text-align:left;
`;
const DropDownContent = styled.div`
    box-sizing:border-box;
    box-shadow: 3px 3px 10px 6px rgba(0,0,0,0.05);
    width:95%;
    position: absolute;
    border-radius: 5px;
    margin-top:8px;
    background-color: var(--color-blanco);
    cursor: pointer;
    max-height:200px;
    overflow:auto;
`;
const DropDownItem = styled.div`
    box-sizing:border-box;
    padding:8px;
    text-align:left;
    :hover{
        background-color: var(--color-rosa);
        color: var(--color-blanco);
        transition: all 0.2s;
    }
    :nth-child(1){
        border-radius:5px 5px 0 0;
    }
    :last-child{
        border-radius: 0 0 5px 5px;
    }
`;

const ModalText = styled.span`
    margin:16px 0;
    font-weight:400;
    span{
        font-weight:700;
        color: var(--color-morado-oscuro);
        :nth-child(2){
             color: var(--color-negro);
        }
    }
`;